import {frameRateLimited} from './util'

export default {
  install (Vue) {
    const windowProps = Vue.observable({
      innerWidth: null,
      innerHeight: null,
      outerWidth: null,
      outerHeight: null,
      scrollX: null,
      scrollY: null
    })

    function onResize () {
      windowProps.innerWidth = window.innerWidth
      windowProps.innerHeight = window.innerHeight
      windowProps.outerWidth = window.outerWidth
      windowProps.outerHeight = window.outerHeight
    }

    function onScroll () {
      windowProps.scrollX = window.scrollX || window.pageXOffset
      windowProps.scrollY = window.scrollY || window.pageYOffset
    }

    onResize()
    onScroll()
    window.addEventListener('resize', frameRateLimited(onResize))
    window.addEventListener('scroll', frameRateLimited(onScroll))

    Vue.prototype.$window = windowProps
  }
}
